import React from "react";
import wordmark from "@/assets/illam-wordmark.png";
import wordmarkLight from "@/assets/illam-wordmark-light.png";
import appicon from "@/assets/illam-appicon.png";

const GRAD_ID = "illam-roof-grad";

function Grad() {
  return (
    <defs>
      <linearGradient id={GRAD_ID} x1="0" y1="1" x2="1" y2="0">
        <stop offset="0" stopColor="#F04E17" />
        <stop offset="0.55" stopColor="#F5691C" />
        <stop offset="1" stopColor="#F9A24B" />
      </linearGradient>
    </defs>
  );
}

// The ILLAM roof mark: bold orange gradient chevron (the "A") with a 4-pane window.
export function IllamMark({ size = 30, windowColor = "#3E3E3E" }) {
  return (
    <svg width={size} height={size * 0.82} viewBox="0 0 40 33" fill="none" aria-hidden>
      <Grad />
      <path
        d="M5 31 L20 5 L35 31"
        stroke={`url(#${GRAD_ID})`}
        strokeWidth="5.2"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
      <g fill={windowColor}>
        <rect x="16.1" y="18.2" width="3.4" height="3.4" rx="0.5" />
        <rect x="20.5" y="18.2" width="3.4" height="3.4" rx="0.5" />
        <rect x="16.1" y="22.6" width="3.4" height="3.4" rx="0.5" />
        <rect x="20.5" y="22.6" width="3.4" height="3.4" rx="0.5" />
      </g>
    </svg>
  );
}

// Official ILLAM app-icon tile (sharp square, site-background fill).
export function IllamAppIcon({ size = 40 }) {
  return (
    <img
      src={appicon}
      alt="ILLAM"
      style={{ width: size, height: size }}
      className="shrink-0 object-contain shadow-sm"
      data-testid="illam-app-icon"
    />
  );
}

// Official ILLAM wordmark lockup (light + dark surface variants).
const LOGO_H = { sm: "h-8", md: "h-9", lg: "h-12" };
export function IllamLogo({ dark = false, className = "", size = "md" }) {
  return (
    <img
      src={dark ? wordmarkLight : wordmark}
      alt="ILLAM — Interiors | Spaces"
      className={`${LOGO_H[size] || LOGO_H.md} w-auto select-none ${className}`}
      data-testid="illam-logo"
    />
  );
}
